<script>
    export default {
        computed: {
            selectFilter() { return this.$store.getters.SELECT_FILTER },
            filters() {return this.$store.getters.FILTERS_NO_CHILD(
                this.$store.getters.CURRENT_ASSET_TYPE
            )}
        },
        methods: {
            async setFilter(event) {
                const targetObject = event.target;

                if (targetObject.checked == true) {
                    this.selectFilter.push(targetObject.value);
                } 
                else {
                    await this.$store.commit('SELECT_FILTER', 
                        this.selectFilter.filter((value) => value !== targetObject.value)
                    );
                }
            }
        }
    }
</script>


<template>
    <div class="left_filter_list">
        <div
            class="left_filter_container"
            v-for="(filterValue, filterIndex) in filters" :key="filterIndex"
        >
            <div class="left_filter_header">
                <label>{{ filterValue.name }}</label>
            </div>
            <div class="left_filter_body">
                <label
                    v-if="filterValue.is_required === false"
                >
                    <input 
                        type="checkbox"
                        :value="`none_${filterValue.id}`"
                        :checked="selectFilter.includes(`none_${filterValue.id}`)"
                        @change="setFilter"
                    >
                    None
                </label>
                <label
                    v-for="(filterItemValue, filterItemIndex) in filterValue.filter_items" :key="filterItemIndex"
                >
                    <input 
                        type="checkbox"
                        :value="`checkbox_${filterItemValue.id}`"
                        :checked="selectFilter.includes(`checkbox_${filterItemValue.id}`)"
                        @change="setFilter"
                    >
                    {{ filterItemValue.name }}
                </label>
            </div>
        </div>
    </div>
</template>